import { useEffect } from "react";
import { useLang } from "@/i18n";

const ORIGIN = "https://dukk.mx";

// Bilingual per-page SEO: lang-aware canonical + es/en hreflang pair.
export default function PageSeo({ esPath, enPath, title, description, image, lang: langProp }) {
  const { lang: ctxLang } = useLang();
  const lang = langProp || ctxLang;
  useEffect(() => {
    const en = lang === "en";
    const canonical = ORIGIN + (en ? enPath : esPath);
    document.documentElement.lang = en ? "en" : "es-MX";
    document.title = title;

    const meta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const alt = (hl, href) => {
      let el = document.head.querySelector(`link[rel="alternate"][hreflang="${hl}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", "alternate"); el.setAttribute("hreflang", hl); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    let c = document.head.querySelector('link[rel="canonical"]:not([hreflang])');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", canonical);

    alt("es-MX", ORIGIN + esPath);
    alt("en", ORIGIN + enPath);
    alt("x-default", ORIGIN + esPath);

    meta("name", "description", description);
    meta("property", "og:title", title);
    meta("property", "og:description", description);
    meta("property", "og:url", canonical);
    meta("property", "og:locale", en ? "en_US" : "es_MX");
    meta("name", "twitter:title", title);
    meta("name", "twitter:description", description);
    if (image) {
      meta("property", "og:image", image);
      meta("property", "og:image:width", "1200");
      meta("property", "og:image:height", "630");
      meta("name", "twitter:image", image);
    }
  }, [lang, title, description, esPath, enPath, image]);
  return null;
}
